import React, { useState } from "react";

type Props = {
  price: number;
  free: any;
};

const OnlinePayment= ({ price, free }: Props) => {
  return (
    <div className="flex flex-col gap-2 items-center justify-center text-white">
      {!free && (
        <>
          <p>
            قيمة المبلغ{" "}
            <span className="font-bold text-lg text-primaryColor">
              {price ? price : "0"}
            </span>{" "}
            جنيه
          </p>
          {price > 0 && <p>سيتم تحويلك الي رابط الدفع للاستكمال</p>}
          {price === 0 && <p>يمكنك الاشتراك مع المدرس مجانا</p>}
        </>
      )}
    </div>
  );
};

export default OnlinePayment;
